import _get from 'lodash/get';
import mm from 'moment';
import Pusher from 'pusher-js';
import { create } from 'apisauce';
import { ContainerIcons } from '@/assets';
import { getAutoComplete } from '@/actions';
export const SizeIcons = (size = '') => {
  let idx = ['20', '40-HC', '40', '45'].findIndex((i) => size.includes(i));
  return ContainerIcons[idx];
};

export const locationOpt = (value) => {
  if (value.trim()) return getAutoComplete(value).then((res) => res);
  return [];
};

export const devMode = process.env.NODE_ENV === 'production';

export const LoggedIn = () => Boolean(localStorage.token);

export const Reject = (data) =>
  Promise.reject(_get(data, 'message', 'something went wrong'));

/** User-facing string from API error body (e.g. Laravel `message` + `errors`). */
export const formatApiErrorMessage = (data) => {
  if (data == null) return 'something went wrong';
  if (typeof data === 'string') return data;
  const baseRaw = data.message != null ? String(data.message).trim() : '';
  const base = baseRaw || 'something went wrong';
  const errors = data.errors;
  if (!errors || typeof errors !== 'object' || Array.isArray(errors)) {
    return base;
  }
  const lines = [];
  for (const msgs of Object.values(errors)) {
    const arr = Array.isArray(msgs) ? msgs : [msgs];
    for (const m of arr) {
      if (m != null && String(m).trim()) lines.push(String(m).trim());
    }
  }
  if (lines.length === 0) return base;
  return `${base}\n${lines.join('\n')}`;
};

export const fTimeDate = (date) => mm(date).format('HH:mm MM-DD-YYYY');
export const fTimeDateUSFormat = (date) => mm(date).format('MM-DD-YYYY HH:mm');
/** Local datetime, e.g. 03-18-26 02:09 */
export const fShortDateTime = (date) => {
  if (date == null || date === '') return '';
  const m = mm(date);
  return m.isValid() ? m.format('MM-DD-YY HH:mm') : '';
};
export const fTimeDateNewLine = (date) => ({
  date: mm(date).format('MM-DD-YYYY'),
  time: mm(date).format('HH:mm'),
});
export const fTime = (date) => mm(date).format('HH:mm');

export const fDate = (date) => mm(date).format('MM-DD-YYYY');
export const fDateTimeNormal = (date) =>
  mm.parseZone(date).format('MM-DD-YYYY HH:mm');

/**
 * Canonical instant (ms) for planner timeline ordering/spacing — must match wall times
 * shown via {@link fDateTimeNormal}. Mixing bare `moment(x)` vs `parseZone`/formats
 * skews comparisons when API mixes ISO-offset, naive local, and `YYYY-MM-DD HH:mm` slots.
 */
export function plannerTimelineInstantMs(raw) {
  if (raw == null || raw === '') return null;
  if (typeof raw === 'number' && Number.isFinite(raw)) return raw;

  const pz = mm.parseZone(raw);
  if (pz.isValid()) return pz.valueOf();

  const naive = mm(raw);
  if (naive.isValid()) return naive.valueOf();

  const str = String(raw).trim();
  const loose = mm(
    str,
    [
      'YYYY-MM-DD HH:mm:ss',
      'YYYY-MM-DD HH:mm',
      'YYYY-MM-DDTHH:mm:ss',
      'MM-DD-YYYY HH:mm',
      'MM-DD-YYYY HH:mm:ss',
    ],
    true
  );
  if (loose.isValid()) return loose.valueOf();

  return null;
}
export const fDate2 = (date) => mm(date).format('MM-DD-YYYY');
export const timeStamp = (date) => mm(date, 'MM/DD/YYYY').unix();
export const pusherKey = process.env.REACT_APP_PUSHER_KEY;

export const genSize = ({ size = '', name = '', model = '' }) =>
  `${size}-${name}-${model}`;

export const pushClient = (channel, fun, ev = 'talk-send-message') => {
  // Enable pusher logging - don't include this in production
  Pusher.logToConsole = false;
  const pusher = new Pusher(pusherKey, {
    cluster: 'us2',
    encrypted: true,
  });

  let conversationChannel = pusher.subscribe(channel);
  conversationChannel.unbind(ev);
  conversationChannel.bind(ev, fun);
  return pusher;
};

// export const playNotificationSound = () => {
//   const audio = new Audio(notificationSound);
//   audio.play();
// };

export const subscribeTokenToTopic = (token, topic) => {
  const api = create({
    baseURL: `https://iid.googleapis.com/iid/v1/${token}/rel/topics/${topic}`,
    headers: {
      Authorization:
        'key=AAAAsbHRjY0:APA91bGVmAvXJkO-TMsR7rXg-wBS1Y3KLFFnZ2HuQg5Jisv1fNgVyCcs1ae6b4FcqRliAkTcdUqILPKg4DfmR6hNW3jGVcb3weCuFXT3ri5D-S64iqbA3zuqm9t9yBbYdxaMJf45w-lr',
    },
  });
  api.post().then(({ status, data, ok }) => {
    if (!ok) {
      console.error('err => ', data);
      console.error(`Error subscribing to topic: ${status} - ${data.text}`);
    }
  });
};

export const toForm = (data) => {
  let formData = new FormData();
  for (let key in data) {
    if (data[key] != null) formData.append(key, data[key]);
  }

  return formData;
};

export const noScroll = (keepScrollbar = false) => {
  document.body.style.overflow = 'hidden';
  if (keepScrollbar)
    document.getElementsByTagName('main')[0].style.paddingRight = `16px`;
  document.getElementsByTagName('main')[0].style.overflow = 'hidden';
};

export const removeNoScroll = () => {
  document.body.style.overflow = '';
  document.getElementsByTagName('main')[0].style.paddingRight = '';
  document.getElementsByTagName('main')[0].style.overflow = '';
};

export { _get };
